<div class="quaterly-feedback-page">
  <div class="breadcrumb">
    <app-breadcrumb [useCaseKey]="useCaseKey" [flowKey]="flowKey"></app-breadcrumb>
  </div>

  <div class="content-area">
    <div class="card-header">
      <h2 class="page-title">Quarterly Feedback</h2>
      <div class="header-actions">
        <app-dropdown
          class="emerald-dropdown dropdown-cls qf-dropdown"
          [options]="yearOptions"
          [label]="'Year'"
          [valueKey]="'value'"
          [displayKey]="'label'"
          [ngModel]="selectedYear"
          [ngModelOptions]="{standalone: true}"
          (selectionChange)="onYearChange($event)"
        ></app-dropdown>
        <app-dropdown
          class="emerald-dropdown dropdown-cls qf-dropdown"
          [options]="quarterOptions"
          [label]="'Quarter'"
          [valueKey]="'value'"
          [displayKey]="'label'"
          [ngModel]="selectedQuarter"
          [ngModelOptions]="{standalone: true}"
          (selectionChange)="onQuarterChange($event)"
        ></app-dropdown>
        <app-button-group
          *ngIf="!isLoading && rowData.length > 0"
          [label]="'Download'"
          [buttonType]="'Primary'"
          [icon]="'download'"
          [iconPosition]="'Left'"
          (onEmit)="onDownload()"
        ></app-button-group>
      </div>
    </div>

    <ng-container *ngIf="!isLoading && rowData.length > 0">
      <app-table
        [columnDefs]="columnDefs"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [enableActions]="tableConfig.enableActions || false"
        [enablePagination]="tableConfig.enablePagination ?? true"
        [paginationPageSize]="tableConfig.paginationPageSize || 20"
        [enableRowSelection]="tableConfig.enableRowSelection || false"
        [enableSorting]="tableConfig.enableSorting ?? true"
        [enableFiltering]="tableConfig.enableFiltering ?? false"
        [enableColumnResize]="tableConfig.enableColumnResize ?? true"
        height="calc(100vh - 230px) "
      ></app-table>
    </ng-container>

    <div *ngIf="!isLoading && rowData.length === 0" class="empty-state">
      <h3 class="empty-state-title">No data available</h3>
      <img src="assets/img/no-data-found.png" alt="No records" class="empty-state-image" />
    </div>
  </div>
</div>